// extracted by mini-css-extract-plugin
export default {"faqWrapper":"Faq_faqWrapper__+1+y8","faqQuestion":"Faq_faqQuestion__a1yb+","faqQuestionText":"Faq_faqQuestionText__NXn0h","faqAnswer":"Faq_faqAnswer__75kgz"};